module.exports = {"name":"html5","type":"adapter","tech":"js","author":"Jordi Aguilar","version":"6.1.4","built":"2018-03-21","repo":"https://bitbucket.org/npaw/html5-adapter-js.git","libVersion":"6.1.14","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getDuration","getIsLive","getResource"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 27
// module chunks = 0